<ng-template #uiRenderer let-_currentData='_currentData'>
  @if (_layout == 'tab' && _currentData.tabType == 'vertical') {
    <div class="backNavigationViewer layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}} _main-container"
      >
      <div #sideBarMenuRef
        [ngClass]="(_layout_data[_layout_id] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] != undefined && _layout_data[_layout_id]['data']['closeSideBar']) || sidebarOpen ? '_main-container sidebar-mini-new' : '_main-container'">
        <div class="_sidebar-menu-container">
          <div class="smc-container">
            <div class="_wf-pp-paddingforsearch ng-star-inserted">
              <div class="_wf-pp-searchinputsubdiva1">
                <div class="_wf-pp-searchiconforsearcha1 smart_menu" title="Smart Menu Enabled ">
                  <div class="_wf-pp-searchkeya1"><i class="fa fa-search"></i></div>
                </div>
                <div action="/search" class="_wf-pp-searchboxsubnewa1"><input type="search" maxlength="256"
                  name="query" id="search" required="" class="_wf-pp-searchinputa1 w-input"
                  placeholder="Search menu" (input)="searchMenu($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="_sidebar-menu">
            @if (_layout_data && checkData(_layout_data)) {
              <div class="">
                @for (layout_key of _layout_data | keys; track layout_key) {
                  @if (_layout_data[layout_key]['data']['permission_required'] ? rolePermissionService.checkAccessPermission(_layout_data[layout_key]['data']['action_name'], _layout_data[layout_key]['data']['resource']) : true) {
                    @if (_layout_data[layout_key]['data']['visible'] || _layout_data[layout_key]['data']['visible'] == undefined) {
                      <div class="_wf-emr-element-indiv"
                        [ngClass]="layout_key == _layout_id ? 'active show' : ''" id="{{layout_key}}"
                        (click)="activeTab(layout_key, _layout_data)">
                        <div class="_wf-emr-icondiv" title="{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}">
                          <div class="_wf-sidebar-icon">
                            <img [src]="'assets/images/'+(_layout_data[layout_key]['data'].icon_name ? _layout_data[layout_key]['data'].icon_name:'file_icon.svg')"
                              alt="" class="nav-icon nav-img-icon">
                          </div>
                          <div class="_snav-mini-text">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</div>
                        </div>
                        <div class="_wf-emr-textforcompnpnet">
                          <div class="text-block-73">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</div>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
          @if (_layout_data && (_layout_data | keyvalue).length > 0) {
            <div class="_wf-emr-element-indiv footer-toggle"
              (click)="sideBarMenuRef.classList.toggle('sidebar-mini-new')">
              <div class="_wf-emr-icondiv">
                <div>
                  <i class="fa fa-arrows-h" aria-hidden="true"></i>
                </div>
              </div>
              <div class="_wf-emr-textforcompnpnet">
                <div class="text-block-73">{{'field.label.compress_menu' | translate | async }}</div>
              </div>
            </div>
          }
        </div>
        <div [ngClass]=" _layout_data[_layout_id] != undefined ? '_main-body container_'+parent_id :'_main-body container_'+parent_id">
          @if (_currentData.showBanner) {
            <div class="banner-container">
              @if (_currentData.bannerJson && parent_id != 2) {
                <app-resource-banner
                  [bannerJson]="_currentData.bannerJson" (patientResult)="getBannerData($event)" (footerLinksClick)="threeDotClick($event)">
                </app-resource-banner>
              }
            </div>
          }
          <div class="billing-content-container">
            <div class="main-container-body container_{{parent_id}} p-0">
              @if (_currentData.resource && _currentData.resource != '' && _currentData.resource != undefined && _currentData.currentAction == 'LIST' && _currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource)) {
                <div class="pull-right card-action-link"
                  >
                  <!-- <a href="javascript:void(0)" (click)="addResource(_currentData.addButton)"><span class="fa fa-plus"></span>&nbsp;Add</a> -->
                  <button class="primary-btn" (click)="addResource(_currentData.addButton)">
                    <span>{{'field.label.add' }}</span>
                    <i class="fa fa-plus-square" aria-hidden="true"></i>
                  </button>
                </div>
              }
              <div id="v-pills-tabContent">
                @if (_currentData.render_template && _currentData.tabType == 'vertical') {
                  <div class="tab-pane kx-v-tab-pane fade active show" id="_layout_id"
                    >
                    <ng-template #parentComponent></ng-template>
                    @if (_currentData && _currentData.resouceDef && _currentData.resouceDef.child_tab) {
                      <div>
                        <div (onCreate)="setDynamicTemplate(parent_id+1, _currentData.resouceDef.child_tab, _currentData.resouceDef.parent_selector)"></div>
                        <!-- <app-ui-engine *ngIf="!_currentData.resouceDef.parent_selector" [resourcename]="_currentData.resouceDef.child_tab" [parent_id]="parent_id+1"></app-ui-engine>  -->
                      </div>
                    } @else {
                      <ng-container [ngTemplateOutlet]="layoutRenderer"
                        [ngTemplateOutletContext]="{_currentData:_currentData}">
                      </ng-container>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (_currentData.resouceDef) {
    <div [ngClass]="_layout == 'tab' && _currentData.tabType!=undefined && _currentData.tabType == 'vertical' ? '' : 'main-content-container'">
      <div [ngClass]="showGridOnly || (_layout == 'tab' && _currentData.tabType == 'vertical') ? '' : 'main-container-body'">
        <!-- change here due dhs form grid action shows banner two times on the screen please review by saurav deep -->
        @if (_currentData.showBanner && !showGridOnly && _currentData.currentAction != 'FORM_GRID') {
          <div>
            @if (_currentData.bannerJson.component == undefined) {
              <app-resource-banner
              [bannerJson]="_currentData.bannerJson" (patientResult)="getBannerData($event)" (footerLinksClick)="threeDotClick($event)"></app-resource-banner>
            }
          </div>
        }
        @if (_layout == 'simple') {
          <div class="page-title-container d-flex">
            @if (_layout == 'simple' && !showGridOnly && !utilService.isOnlyMobile() && (utilService.getWidth() > utilService.getHeight())) {
              <div class="page-title flex-grow-1">
                @if (_currentData.currentAction == 'LIST') {
                  <div class="mb-0">
                    @if (_layout_data.config != undefined && _layout_data.config.list_back_navigation === true ? true : false) {
                      <div class="pr-2"
                        >
                        <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                          <img src="assets/images/grid-back.png" />
                        </a>
                        {{baseService._currentTitle}}
                      </div>
                    } @else {
                      {{baseService._currentTitle}}
                    }
                  </div>
                }
                @if (_currentData.currentAction != 'LIST' && (_layout_data.config != undefined && _layout_data.config.show_title === false ? false : true)) {
                  <div
                    class="mb-0">
                    <div class="d-flex align-items-center">
                      @if ((_currentData.currentAction != 'FORM_GRID' && (_layout_data!=undefined && _layout_data.config!=undefined &&_layout_data.config.back_navigation!=undefined && _layout_data.config.back_navigation === false ? false : true)) || (_currentData.currentAction == 'FORM_GRID' && (_layout_data!=undefined && _layout_data.config!=undefined && _layout_data.config.form_grid_back_navigation!=undefined &&_layout_data.config.form_grid_back_navigation ? true : false))) {
                        <div class="pl-2 pr-2"
                          >
                          <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                            <img src="assets/images/grid-back.png" />
                          </a>
                        </div>
                      }
                      <div class="">
                        {{baseService._currentTitle}}
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (_layout == 'simple') {
              <div class="component-container ml-auto">
                <div [ngClass]="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table && !utilService.isMobile() ? 'top-actions': ''">
                  @if ((_currentData.currentAction == 'LIST' || _currentData.currentAction == 'IMAGE_VIEWER') && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed && (_currentData.ruleEngine['add'] == undefined || (_currentData.ruleEngine['add'] != undefined && _currentData.ruleEngine['add']))) {
                    <ng-container [ngTemplateOutlet]="addRenderer"
                      [ngTemplateOutletContext]="{_currentData:_currentData}">
                    </ng-container>
                  }
                  <ng-container [ngTemplateOutlet]="switchRenderer"
                    [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                </div>
              </div>
            }
          </div>
        }
        @if (_layout == 'simple' && _currentData.render_template) {
          <div class="app-ui-engine-container main-box-shadow layout_simple layout_simple_{{_currentData.currentResource}}"
            >
            <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
            </ng-container>
          </div>
        }
        @if (_layout == 'tab') {
          <div class="layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}}"
            >
            @if (!utilService.isMobile()) {
              <div class="d-flex align-items-center">
                @if (_currentData.list_back_navigation === true ? true : false) {
                  <a class="pl-2 pr-2 d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                    <img src="assets/images/grid-back.png" />
                  </a>
                  {{baseService._currentTitle}}
                }
              </div>
            }
            @if (_currentData.tabType == 'horizontal' || _currentData.tabType == 'radio') {
              <div class="layout_tab_horizontal layout_tab_horizontal_{{_layout_id}}"
                style="background-color: white;position: relative;">
                <ul class="base-tab" id="tab_{{_currentData.json}}" #tabWidth_ [ngClass]="{'tabWithoutButtons':!(tab_+_currentData.json | getHeight:tabWidth:'tabWidth')}">
                  @if ((tab_+_currentData.json | getHeight:tabWidth:'tabWidth') | async) {
                    <div class="scroll-btn-move scroll-btn-move-prev">
                      <div class="_tab-expand" (click)="toggleTabView($event)" title="Expand Tabs">
                        <i class="fa fa-chevron-down" aria-hidden="true"></i>
                        <i class="fa fa-chevron-up" aria-hidden="true"></i>
                      </div>
                      <div class="tab-prev tab-scroll-actions" (click)="scrolltab('tab_'+_currentData.json,'right')">
                        <div class="tab-prev-circle">
                          <i class="fa fa-angle-left" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="d-flex flex-wrap">
                    @if (_currentData.tabType == 'radio') {
                      @for (layout_key of _layout_data | keys; track layout_key) {
                        <li class="nav-item m-2" style="width: 180px;">
                          <!-- {{_layout_data | json}} -->
                          <div class="radio" (click)="activeTab(layout_key)">
                            <label class="kx-radio-wrapper">
                              {{_layout_data[layout_key]['data']['layoutName'] | translate | async }}
                              <input type="radio" value="{{_layout_data[layout_key]['data']['layoutName']}}"
                                name="radio" [checked]="layout_key == _layout_id">
                              <span class="kx-radio-check"></span>
                            </label>
                          </div>
                        </li>
                      }
                    }
                  </div>
                  @if (_currentData.tabType == 'horizontal') {
                    @for (layout_key of _layout_data | keys; track layout_key) {
                      @if (_layout_data[layout_key] != undefined) {
                        <li class="nav-item">
                          <a class="nav-link" [ngClass]="layout_key == _layout_id ? 'active' : ''"
                            (click)="activeTab(layout_key)" data-toggle="tab"
                          role="tab">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
                        </li>
                      }
                    }
                  }
                  @if (tab_+_currentData.json | getHeight:tabWidth:'tabWidth') {
                    <div class="scroll-btn-move">
                      <div class="tab-next tab-scroll-actions">
                        <div class="tab-prev-circle" (click)="scrolltab('tab_'+_currentData.json,'left')">
                          <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  }
                </ul>
                @if (_currentData.render_template) {
                  <div [ngClass]="{'base-tab-content':_currentData.tabType != 'radio'}" id="_layout_id">
                    <!---action button in case of Tabs : added by abhinav chauhan-->
                    <div class="d-flex justify-content-end">
                      @if (_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed) {
                        <ng-container [ngTemplateOutlet]="addRenderer"
                          [ngTemplateOutletContext]="{_currentData:_currentData}">
                        </ng-container>
                      }
                      <ng-container [ngTemplateOutlet]="switchRenderer"
                        [ngTemplateOutletContext]="{_currentData:_currentData}">
                      </ng-container>
                      @if (rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                        <div class="table-view-toggle tab-settings-button" >
                          <span class="toggle-icn">
                            <i title="{{'cv' | translate | async}}" (click)="configUIEngine({context:'ui'})" class="fa fa-cog"></i>
                          </span>
                        </div>
                      }
                    </div>
                    <ng-template #parentComponent></ng-template>
                    @if (_currentData.resouceDef && _currentData.resouceDef.child_tab) {
                      <div>
                        <div (onCreate)="setDynamicTemplate(parent_id+1, _currentData.resouceDef.child_tab, _currentData.resouceDef.parent_selector)"></div>
                        <!-- <app-ui-engine *ngIf="!_currentData.resouceDef.parent_selector" [resourcename]="_currentData.resouceDef.child_tab" [parent_id]="parent_id+1"></app-ui-engine>  -->
                      </div>
                    } @else {
                      <ng-container [ngTemplateOutlet]="layoutRenderer"
                        [ngTemplateOutletContext]="{_currentData:_currentData}">
                      </ng-container>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <ng-template #switchRenderer let-_currentData='_currentData'>
    <!-- <div (click)="gridPopupApi()" *ngIf="_currentData.dataGridConfig.gridPopupValidation && _currentData?.resouceDef?.config?.gridPopupIcon != undefined" class="recent_patient_css" style="margin-left: auto;">
    <img src="./assets/images/{{_currentData.resouceDef.config.gridPopupIcon}}">
  </div> -->
  <!-- <div class="table-view-toggle"
  *ngIf="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table">
  <ng-template #swithcToCard>
    Switch Card Layout
  </ng-template>
  <ng-template #swithcToTable>
    Switch Table Layout
  </ng-template>
  <span class="toggle-icn">
    <i *ngIf="_currentData.config.activeField == 'table'" class="fa fa-th"
    (click)="switchView('tile');" [popover]="swithcToCard" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
    <i *ngIf="_currentData.config.activeField == 'tile'" class="fa fa-list"
    (click)="switchView('table');" [popover]="swithcToTable" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
  </span>
</div> -->
</ng-template>
<ng-template #addRenderer let-_currentData='_currentData'>
  <!--button in case of grid : added by abhinav chauhan-->
  @if (_currentData.addButton == undefined && !showGridOnly) {
    @if (!utilService.isMobile()) {
      <button class="primary-btn" (click)="addResource()">
        <span>{{'button.add' | translate | async }}</span>
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    }
    <!--for mobile fixed button-->
    @if (utilService.isMobile();) {
      <button class="mobile-primary-btn" (click)="addResource()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <div>{{'button.add' | translate | async }}</div>
      </button>
    }
  }
  @if (_currentData.addButton != undefined && _currentData.addButton.type == 'button' && !utilService.isMobile()) {
    @if (_currentData.showAddButton) {
      <button class="primary-btn" (click)="addResource(_currentData.addButton)">
        <span>{{_currentData.addButton.label | translate | async }}</span>
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    }
  }
  @if (_currentData.addButton != undefined && _currentData.addButton.type == 'button' && utilService.isMobile()) {
    @if (_currentData.showAddButton) {
      <button class="mobile-primary-btn" (click)="addResource(_currentData.addButton)">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <div>{{_currentData.addButton.label | translate | async }}</div>
      </button>
    }
  }
  @if (_currentData.addButton != undefined && _currentData.addButton.type == 'search') {
    @if (_currentData.showAddButton) {
      <button class="primary-btn" type="button" (click)="addButtonAction();">
        <span>{{_currentData.addButton.label | translate | async}}</span>
        <i class="fa fa-plus-circle" aria-hidden="true"></i>
      </button>
    }
    @if (!_currentData.showAddButton) {
      <div class="inputSearchElementcontainer" style="z-index:2; position:relative; width:400px;"
        >
        <input-search id="inputSearchElement" [data]="_currentData.addButton"
          (selectedItemsData)="selectedItemsData($event)" [qrCodeScanner]="_currentData.addButton.qrCodeScanner" [showAdvSearch]="true"
          [placeholder]="_currentData.addButton.hint" (patientResult)="settingUserInfo($event)"
          (labelEvent)="InputEvent($event);" (closeOverlay)="closesOverlay();">
      </input-search>
    </div>
  }
  @if (!_currentData.showAddButton) {
    <div class="cstmOverlay"></div>
  }
}
</ng-template>
<ng-template #layoutRenderer let-_currentData='_currentData'>
  @if (_currentData.currentAction === 'EDIT_GRID') {
    <div>
      <dhs-editable-grid [resource]="_currentData.resouceDef.resource"> </dhs-editable-grid>
    </div>
  }
  @if (_currentData.currentAction === 'EDITGRID') {
    <div>
      <kx-editable-grid-with-banner [resource]="_currentData.resouceDef.resource">
      </kx-editable-grid-with-banner>
    </div>
  }
  <!-- Form and grid both render -->
  @if (_currentData.currentAction === 'FORM_GRID' && _currentData.resouceDef.resource) {
    <div>
      <dhs-form-grid (bulkActionClicked)="onBulkActionClicked($event)" [addAllowed] = _currentData.addAllowed
        [resourceName]="_currentData.resouceDef.resource" (editEllipseClick)="buttonAction($event)" [layoutName]="_currentData.tabLayoutName">
      </dhs-form-grid>
    </div>
  }
  @if (_currentData.currentAction === 'IMAGE_VIEWER') {
    <div>
      <app-document-viewer [resourceName]="_currentData.resouceDef.resource"></app-document-viewer>
    </div>
  }

  @if ((_currentData.currentFormFields.loaded == undefined) || _currentData.currentFormFields.loaded) {
    <div [ngClass]="_currentData.temp ? '_template-form' : ''">
      @if (_currentData.currentAction === 'ADD') {
        <dhs-form [action]="_currentData.currentAction"
          [bookmarks]="_currentData.bookmarks" [data]="_currentData.defaultFormData" [casesheet]="_currentData.casesheet"
          [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.configForm"
          [decorator]="_currentData.decorator" [customButton]="_currentData.customButton"
          (saveFinished)="onSaveFinished($event)" (tabclicked)="onFormTab($event)" #formComponenet
          [formName]="_currentData?.formName"
          >
        </dhs-form>
      }
      @if (_currentData.currentData && _currentData.currentAction === 'MODIFY') {
        <dhs-form [casesheet]="_currentData.casesheet"
          [action]="_currentData.currentAction" [bookmarks]="_currentData.bookmarks" [fieldGroup]="_currentData.currentFormFields"
          [config]="_currentData.configForm" [data]="_currentData.currentData" (saveFinished)="onSaveFinished($event)"
          [decorator]="_currentData.decorator" [customButton]="_currentData.customButton" (tabclicked)="onFormTab($event)" #formComponenet>
        </dhs-form>
      }
      @if (_currentData.currentData && _currentData.currentAction === 'VIEW') {
        <dhs-form-view
          [fieldGroup]="_currentData.currentFormFields" [data]="_currentData.currentData"
          [buttonConf]="_currentData.popUiengineConfig != undefined && _currentData.popUiengineConfig.buttonConf !=undefined ? _currentData.popUiengineConfig.buttonConf:true">
        </dhs-form-view>
      }
    </div>
  }
  @if ((_currentData.currentAction === 'ADD' || _currentData.currentAction === 'MODIFY' || _currentData.currentAction === 'VIEW')  && (!((_currentData.currentFormFields.loaded == undefined) || _currentData.currentFormFields.loaded))) {
    <div class=""
      >
      <div class="ui_engine_loading">Loading...</div>
    </div>
  }
  @if (_currentData.dataList != null && _currentData.showView) {
    <div id="ui_{{_currentData.resource}}">
      @if (_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS') {
        <dhs-data-grid
          [fields]="_currentData.currentListFields" [cardHeaders]="_currentData.cardHeader" [legend]="_currentData.legend"
          [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList" [extra_buttons]="_currentData.extra_buttons"
          [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick" (configValues)="getConfigValues($event)"
          (bulkActionClicked)="onBulkActionClicked($event)" (bindGrid)="bindDataToGrid($event)" (actionClicked)="actionClicked($event)"
          (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)" [cardResourceMbl]="_currentData.mobile_card_resource"
          (editEllipseClick)="buttonAction($event)" (onPageChanges)="pageChanges($event)" (gridPopupClicked)="gridPopupApi()"
          (onSortChanges)="sortChanges($event);" [config]="_currentData.dataGridConfig">
        </dhs-data-grid>
      }
      <!-- <app-summary-engine
      *ngIf="(_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS') && _currentData.summary && _currentData.summary.blocks && _currentData.dataList && _currentData.dataList.resource && _currentData.dataList.resource.length > 0"
      [_summaryData]="_currentData.summary" [gridData]="_currentData.gridData"
      (summaryResponse)="getSummaryResponse($event)">
    </app-summary-engine> -->
  </div>
}

<ng-template #customComponent>
</ng-template>
</ng-template>
<div dhs-modal></div>
</ng-template>

<ng-container [ngTemplateOutlet]="uiRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
</ng-container>
